<fury-page-layout mode="card">
    <fury-page-layout-header>
      <fury-breadcrumbs [@fadeInRight]  current={{filterValue}}></fury-breadcrumbs>
    </fury-page-layout-header>
  
    <fury-page-layout-content [@fadeInUp]>
      <fury-list name={{filterValue}} [columns]="columns" (filterChange)="onFilterChange($event)">
        <div style="position: relative;" class="filter">
            <button class="filter fury-column-filter" type="button" mat-icon-button (click)="showFilter()">
              <img src="../../../assets/img/filter.png" alt="filter"/>
            </button>
            <div class="filteringprt" *ngIf="isShowFilter">
              <form [formGroup]="filterForm">
              <h3 style="margin: 0;">Filter</h3>
              <mat-form-field appearance="outline">
                <mat-label>Search By</mat-label>
                <mat-select formControlName="searchBy">
                  <mat-option *ngFor="let item of serchByValue" [value]="item?.value">{{item.title}}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Search Type</mat-label>
                <mat-select formControlName="searchType">
                  <mat-option *ngFor="let item of commonService.searchTypeValue" [value]="item?.value">{{item.title}}</mat-option>
                </mat-select>
              </mat-form-field>
              <div class="btnprt">
                <button mat-button class="can-button" (click)="showFilter()">Cancel</button>
                <button mat-button class="sub-button" (click)="filterChange()">Search</button>
              </div>
            </form>
            </div>
          </div>

          <div class="table_container">
            <table [dataSource]="dataSource" mat-table>
               

                <ng-container matColumnDef="actions" stickyEnd>
                    <th *matHeaderCellDef class="actions-cell" mat-header-cell>Actions</th>
                    <td *matCellDef="let row;let i=index" class="actions-cell" mat-cell>
                        <button type="button" mat-icon-button [matMenuTriggerFor]="actionsMenu"
                            (click)="$event.stopPropagation()">
                            <mat-icon>more_horiz</mat-icon>
                        </button>
                        <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                            <button mat-menu-item [routerLink]="['/reputation/feedback-details', row?.reviewId]">
                                <span>View</span>
                            </button>
                        </mat-menu>
                    </td>
                </ng-container>
    
                <ng-container matColumnDef="reviewSubmittedAt">
                    <th mat-header-cell *matHeaderCellDef>Added On</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.reviewSubmittedAt | date : 'MMM-dd-YYYY h:mm a'}}
                    </td>
                </ng-container>
    
                <ng-container matColumnDef="feedback">
                    <th mat-header-cell *matHeaderCellDef>
                        <span class="cursorPointer" (click)="orderEvent('feedback')">Feedback
                            <mat-icon *ngIf="arrowChanges.feedback === 'DESC'">arrow_downward</mat-icon>
                            <mat-icon *ngIf="arrowChanges.feedback !== 'DESC'">arrow_upward</mat-icon>
                        </span></th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.feedback}}
                    </td>
                </ng-container>
                
                <ng-container matColumnDef="firstName">
                    <th mat-header-cell *matHeaderCellDef>First Name</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.reviewDetails?.firstName}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="lastName">
                    <th mat-header-cell *matHeaderCellDef>Last Name</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.reviewDetails?.lastName}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="emailAddress">
                    <th mat-header-cell *matHeaderCellDef>Email Address</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.reviewDetails?.emailAddress}}
                    </td>
                </ng-container>
                
                <ng-container matColumnDef="phoneNumber">
                    <th mat-header-cell *matHeaderCellDef>Phone Number</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.reviewDetails?.phoneNumber}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="reviewStatus" stickyEnd>
                    <th mat-header-cell *matHeaderCellDef>
                        <span class="cursorPointer" (click)="orderEvent('status')">Status
                            <mat-icon *ngIf="arrowChanges.status === 'DESC'">arrow_downward</mat-icon>
                            <mat-icon *ngIf="arrowChanges.status !== 'DESC'">arrow_upward</mat-icon>
                        </span></th>
                    <td mat-cell *matCellDef="let element">
                        <span [class]="element?.reviewStatus" (click)="openDialog(element)">{{element?.reviewStatus}}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="ipAddress">
                    <th mat-header-cell *matHeaderCellDef>
                        <span class="cursorPointer" (click)="orderEvent('ipAddress')">Ip Address
                            <mat-icon *ngIf="arrowChanges.ipAddress === 'DESC'">arrow_downward</mat-icon>
                            <mat-icon *ngIf="arrowChanges.ipAddress !== 'DESC'">arrow_upward</mat-icon>
                        </span></th>
                    <td mat-cell *matCellDef="let element">
                       {{element?.ipAddress}}
                    </td>
                </ng-container>
               
                <tr *matHeaderRowDef="visibleColumns; sticky: true" mat-header-row></tr>
                <tr *matRowDef="let row; columns: visibleColumns | paginate: { id: 'server', itemsPerPage: pageSize, currentPage: pageIndex, totalItems: totalCount }"
                    class="clickable route-animations-elements" mat-row>
                </tr>
            </table>
          </div>

       
        <div *ngIf="itemList?.length === 0" style="padding: 10px 0; text-align:center;">
            No Feedback found.
        </div>
          <mat-paginator [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="pageSize" [length]="totalCount" [pageIndex]="pageIndex" (page)="pageSizeChange($event)"
                  showFirstLastButtons
                  [selectConfig] = "selectConfig"
                  [ngClass]="{'mat-pegig': pageSize === 9999}"
                  aria-label="Select page of periodic elements">
              </mat-paginator>
  
      </fury-list>
  
    </fury-page-layout-content>
  </fury-page-layout>
  



